import { Routes } from '@models/route';
import { lazy } from 'react';

const ListUsers = lazy(() =>
  import('@pages/users/list-users').then((p) => ({
    default: p.ListUsers
  }))
);

const CreateUser = lazy(() =>
  import('@pages/users/create-user').then((p) => ({
    default: p.CreateUser
  }))
);

const ViewUser = lazy(() =>
  import('@pages/users/view-user').then((p) => ({
    default: p.ViewUser
  }))
);

export const UserRoutes: Routes = [
  {
    path: '/Users',
    component: ListUsers,
    children: [
      {
        path: 'create',
        component: CreateUser
      },
      {
        path: ':id',
        component: ViewUser
      }
    ]
  }
];
